import { ComponentStore } from '@ngrx/component-store';
import {  tapResponse } from '@ngrx/operators';
import { ZohoSettingsService } from './zoho-settings.service';
import { Injectable } from '@angular/core';
import { mergeMap, pipe, Subject } from 'rxjs';
import { Router } from '@angular/router';

interface ZohoSettingsState {
  status: 'unknown' | 'connecting' | 'connected' | 'disconnected' | 'error';
  accounts: any[];
  taxRates: any[];
}

const initialState: ZohoSettingsState = {
  status: 'unknown',
  accounts: [],
  taxRates: []
};

@Injectable()
export class ZohoSettingsStore extends ComponentStore<ZohoSettingsState> {
  constructor(
    private zohoSettingsService: ZohoSettingsService,
    private router: Router
  ) {
    super(initialState);
  }

  readonly status$ = this.select((state) => state.status);
  readonly accounts$ = this.select((state) => state.accounts);
  readonly taxRates$ = this.select((state) => state.taxRates);
  readonly onConnect = new Subject<string>();
  readonly onRedirectToZoho = new Subject<void>();

  private readonly getConnectedStatus = this.effect(() => {
    return this.zohoSettingsService.getZohoStatus().pipe(
      tapResponse(
        (data: { connected: boolean }) => {
          this.patchState({
            status: data.connected ? 'connected' : 'disconnected'
          });
        },
        (error) => {
          console.log(error);
        }
      )
    );
  });

  readonly attemptZohoConnection = this.effect<void>(
    pipe(
      mergeMap(() => {
        return this.zohoSettingsService.getZohoConnectionUrl().pipe(
          tapResponse(
            (data: { url: string }) => {
              window.location.href = data.url;
            },
            (error) => {
              console.log(error);
            }
          )
        );
      })
    )
  );

  readonly connectAccount = this.effect<string>(
    pipe(
      mergeMap((code: string) => {
        return this.zohoSettingsService.connect(code).pipe(
          tapResponse(
            () => {
              this.patchState({
                status: 'connected'
              });
              this.router.navigate(['/settings']);
            },
            (error) => {
              console.log(error);
              this.router.navigate(['/settings']);
            }
          )
        );
      })
    )
  );

  readonly disconnect = this.effect<void>(
    pipe(
      mergeMap(() => {
        return this.zohoSettingsService.disconnect().pipe(
          tapResponse(
            () => this.getConnectedStatus(),
            (error) => {
              console.log(error);
            }
          )
        );
      })
    )
  );
}
